const Report = () =>
  import(
    /* webpackChunkName: "crm-contact" */ '@/pages/crm/contact/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "crm-contact" */ '@/pages/crm/contact/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "crm-contact" */ '@/pages/crm/contact/edit.vue'
  )

export default {
  path: 'contact',
  meta: {
    label: 'contact',
    auth: 'contact'
  },
  component: {
    name: 'Contact',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CrmContactReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'CrmCreateContact',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CrmEditContact',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
